module.exports = __webpack_public_path__ + "img/-LV58ZtJA8M7dtR9rX-U.7a0e5a3e.jpg";